import React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import "./styles.css";
import { CheckIcon } from "components/icons";

type Props = {
  label: string;
};
export const Checkbox: React.FC<Props> = ({ label }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <CheckboxPrimitive.Root className="CheckboxRoot" defaultChecked id="c1">
        <CheckboxPrimitive.Indicator className="CheckboxIndicator">
          <CheckIcon fill="#ffffff" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label className="Label" htmlFor="c1">
        {label}
      </label>
    </div>
  );
};
